import "../../chunk-7QVYU63E.js";
import { NetworkIdSchema } from "#network/network.js";
import { z } from "zod";
const LogSchema = z.object({
  id: z.string().min(1),
  appId: z.string(),
  appName: z.string(),
  network: NetworkIdSchema.optional(),
  method: z.string(),
  duration: z.number(),
  fcu: z.number(),
  numRequestsInBatch: z.number(),
  requestBody: z.string(),
  requestBodyIsValid: z.boolean(),
  requestQuery: z.string(),
  responseBody: z.string(),
  responseBodyIsValid: z.boolean(),
  responseErrorCode: z.number(),
  responseHttpStatusCode: z.number(),
  sentAt: z.string().datetime()
});
export {
  LogSchema
};
//# sourceMappingURL=logs.js.map